// src/pages/admin/ProjectsList.js
import React from 'react';
import { Card, List, Avatar, Button } from 'antd';
import { ProjectOutlined } from '@ant-design/icons';

const ProjectsList = ({ projects, users, navigate }) => (
  <Card title="Recent Projects" bordered={false} style={{ marginTop: 16 }}>
    <List
      itemLayout={window.innerWidth < 768 ? 'vertical' : 'horizontal'}
      dataSource={projects.slice(0, 5)}
      renderItem={(item) => (
        <List.Item
          actions={[
            <Button type="link" onClick={() => navigate(`/admin/student/projects/${item.id}`)}>View</Button>,
          ]}
        >
          <List.Item.Meta
            avatar={<Avatar icon={<ProjectOutlined />} />}
            title={item.title}
            description={`User: ${users.find(u => u.id === item.userId)?.name || 'Unknown'} | Status: ${item.status}`}
          />
        </List.Item>
      )}
    />
  </Card>
);

export default ProjectsList;